import { useEffect, useState } from 'react'

// True on small (phone-sized) viewports. Kept in one place so the CRM's
// mobile/desktop branch points (modal vs. page, layout) stay in sync with the
// SCSS breakpoint of 768px.
const QUERY = '(max-width: 768px)'

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(
        () => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(QUERY).matches
    )

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return undefined
        const mql = window.matchMedia(QUERY)
        const onChange = (e) => setIsMobile(e.matches)
        setIsMobile(mql.matches)
        // addEventListener is the modern API; addListener is the Safari <14 fallback.
        if (mql.addEventListener) mql.addEventListener('change', onChange)
        else mql.addListener(onChange)
        return () => {
            if (mql.removeEventListener) mql.removeEventListener('change', onChange)
            else mql.removeListener(onChange)
        }
    }, [])

    return isMobile
}
